import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../components/ui/button";
import Common from "../../helper/common";
import AdvanceTable from "../../components/advanceTable";
import AddTax from "./addTax";
import { respEnum } from "../../constants/appConstant";

import { TaxTypeEnum } from "../../constants/appConstant";

const Tax = () => {
  const [data, setData] = useState({});
  const [open, setOpen] = useState(false);
  const [refId, setRefId] = useState(null);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (!open && refId) {
      setRefId(null);
    }
  }, [open]);

  const getData = async () => {
    try {
      const response = await Common.ApiService.getInstance().request(
        "GetTaxList",
        {},
        "GET"
      );

      if (response?.status === respEnum.Success && response?.data) {
        let processed = response.data.map((item) => ({
          ...item,
          type: item.type === TaxTypeEnum.Inclusive ? "Inclusive" : item.type === TaxTypeEnum.Exclusive ? "Exclusive" : item.type,
          isactive: item.isactive ? "Yes" : "No",
          percentage: item.percentage ? `${item.percentage}%` : "0%",
        createdon: item.createdon
                      ? Common.Utility.ConvertTime(item.createdon)
                      : null,
        updatedon: item.updatedon
                    ? Common.Utility.ConvertTime(item.updatedon)
                    : null,                      
        //   updatedon: Common.Utility.ConvertTime(item.updatedon),
          createdby: item.createdbyName || "N/A",
          updatedby: item.updatedbyName || "N/A",
        }));

        setData({
          data: processed,
        });
      }
    } catch (error) {
      console.error("Error fetching tax list:", error);
      Common.SweetAlert.alert("Failed to load tax list", "error");
    }
  };

  const columns = [
    { title: "Id", type: "number", isVisible: false, key: "id" },
    { title: "Name", type: "text", isVisible: true, key: "name" },
    { title: "Type", type: "text", isVisible: true, key: "type" },
    {
      title: "Percentage",
      type: "text",
      isVisible: true,
      key: "percentage",
    },
    { title: "Active", type: "text", isVisible: true, key: "isactive" },
    { title: "Created On", type: "text", isVisible: true, key: "createdon" },
    { title: "Updated On", type: "text", isVisible: true, key: "updatedon" },
    { title: "Created By", type: "text", isVisible: true, key: "createdby" },
    { title: "Updated By", type: "text", isVisible: true, key: "updatedby" },
  ];

  const actions = [
    {
      type: "edit",
      onClick: (val) => _onEdit(val.id),
    },
    {
      type: "delete",
      onClick: (val) => _handleDelete(val.id),
    },
  ];

  const _onEdit = async (id) => {
    setOpen(true);
    setRefId(id);
  };

  const _handleDelete = async (id) => {
    const isConfirmed = await Common.SweetAlert.confirmation(
      "Are you sure you want to delete this Tax?",
      "Delete Tax"
    );
    if (isConfirmed) {
      try {
        let resp = await Common.ApiService.getInstance().request(
          `DeleteTax?id=${id}`,
          {},
          "POST"
        );

        if (resp.status === respEnum.Success) {
          Common.SweetAlert.alert(resp.message, "success");
          setTimeout(() => {
            getData();
          }, 500);
        } else {
          Common.SweetAlert.alert(
            resp.message || "Failed to delete tax",
            "error"
          );
        }
      } catch (error) {
        console.error("Error deleting tax:", error);
        Common.SweetAlert.alert("Failed to delete tax", "error");
      }
    }
  };

  const _addUpdateTrigger = () => (
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>
  );



  return (
    <>
      {data?.data && (
        <AdvanceTable
          title={"Tax"}
          columns={columns.filter((item) => item.isVisible)}
          data={data}
          getData={getData}
          showAddButton
          actionButtons={actions}
          addButton={() => (
            <AddTax
              id={refId}
                onClose={() => getData()}
              open={open}
              setOpen={setOpen}
            />
          )}
          updateTrigger={_addUpdateTrigger}
        />
      )}
    </>
  );
};

export default Tax;
